import subusersApi from '@/api/subusers'

const getDefaultState = () => {
  return {
    list: []
  }
}

const state = getDefaultState()

const mutations = {
  ADD_SUBUSER: (state, user) => {
    state.list = [...state.list, user]
  },
  SET_USERS: (state, usersList) => {
    state.list = [...usersList]
  },
  UPDATE_SUBUSER: (state, user) => {
    state.list = state.list.map(subuser => {
      if (subuser.id === user.id) {
        return user
      }

      return subuser
    })
  }
}

const actions = {
  async createSubuser ({ commit }, data) {
    const subuser = {
      sub_user: { ...data }
    }

    const { response, error } = await subusersApi.createSubuser(subuser)

    if (response) {
      commit('ADD_SUBUSER', response.data)

      return { response }
    }

    return { error }
  },
  async getUsers ({ commit }) {
    const { data } = await subusersApi.getSubusers()

    commit('SET_USERS', data)
  },
  async updateSubuser ({ commit }, { id, data }) {
    const subuser = {
      sub_user: { ...data }
    }

    const { response, error } = await subusersApi.updateSubuser(id, subuser)

    if (response) {
      commit('UPDATE_SUBUSER', response.data)

      return { response }
    }

    return { error }
  }
}

const getters = {
  subusers: (state) => {
    return state.list
  },
  operator: (state) => {
    const operator = state.list.find(user => user.role === 'operator')

    return operator || null
  },
  reporter: (state) => {
    const reporter = state.list.find(user => user.role === 'reporter')

    return reporter || null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
